export const automationIds = {
    NAV_LINK: {
        CLIENTS: 'CLIENTS_NAV_LINK',
        ADMINS: 'ADMINS_NAV_LINK',
        PROFILE: 'PROFILE_NAV_LINK',
        HOME: 'HOME_NAV_LINK',
        COMPANIES: 'COMPANIES_NAV_LINK',
        USERS: 'USERS_NAV_LINK',
        CALCULATIONS: 'CALCULATIONS_NAV_LINK',
        DOCUMENTS: 'DOCUMENTS_NAV_LINK'
    },
    TABLE_HEADER: {
        NAME: 'NAME_TABLE_HEADER',
        EMAIL: 'EMAIL_TABLE_HEADER',
        STATUS: 'STATUS_TABLE_HEADER',
        STATEMENT_STATUS: 'STATEMENT_STATUS_TABLE_HEADER',
        RECEIPT_STATUS: 'RECEIPT_STATUS_TABLE_HEADER',
        DATE: 'DATE_TABLE_HEADER',
        UPDATED_BY: 'UPDATED_BY_TABLE_HEADER',
        FISCAL_IDENTIFIER: 'FISCAL_IDENTIFIER_TABLE_HEADER',
        NUMBER_OF_COMPANIES: 'NUMBER_OF_COMPANIES_TABLE_HEADER',
        ROLES: 'ROLES_TABLE_HEADER',
        NUMBER_OF_USERS: 'NUMBER_OF_USERS_TABLE_HEADER',
        NUMBER_OF_ACTIVE_USERS: 'NUMBER_OF_ACTIVE_USERS_TABLE_HEADER',
        STORAGE: 'STORAGE_TABLE_HEADER',
        EXTRA_FEATURES: 'EXTRA_FEATURES_TABLE_HEADER',
        CLIENT_NAME: 'CLIENT_NAME_TABLE_HEADER',
        COMPANY_NAME: 'COMPANY_NAME_TABLE_HEADER',
        STATEMENT_TYPE: 'STATEMENT_TYPE_TABLE_HEADER',
        NUMBER_OF_CLIENTS: 'NUMBER_OF_CLIENTS_TABLE_HEADER',
        ACCOUNT: 'ACCOUNT_TABLE_HEADER',
        ACCOUNT_DESCRIPTION: 'ACCOUNT_DESCRIPTION_TABLE_HEADER',
        INITIAL_DEBIT: 'INITIAL_DEBIT_TABLE_HEADER',
        INITIAL_CREDIT: 'INITIAL_CREDIT_TABLE_HEADER',
        CUMULATIVE_DEBIT: 'CUMULATIVE_DEBIT_TABLE_HEADER',
        CUMULATIVE_CREDIT: 'CUMULATIVE_CREDIT_TABLE_HEADER',
        FINAL_DEBIT: 'FINAL_DEBIT_TABLE_HEADER',
        FINAL_CREDIT: 'FINAL_CREDIT_TABLE_HEADER',
        QUARTER: 'QUARTER_TABLE_HEADER',
        YEAR: 'YEAR_TABLE_HEADER',
        MAX_USAGE_YEAR: 'MAX_USAGE_YEAR_TABLE_HEADER',
        ATTACHED_DOCUMENT_NAME: 'ATTACHED_DOCUMENT_NAME_TABLE_HEADER',
        DOCUMENT_NAME: 'DOCUMENT_NAME_TABLE_HEADER',
        DOCUMENT_CATEGORY: 'DOCUMENT_CATEGORY_TABLE_HEADER',
        NUMBER_OF_CALCULATIONS: 'NUMBER_OF_CALCULATIONS_TABLE_HEADER',
        UPLOAD_DATE: 'UPLOAD_DATE_TABLE_HEADER',
        MB_SIZE: 'MB_SIZE_TABLE_HEADER',
        SUBMISSION_DATE: 'SUBMISSION_DATE_TABLE_HEADER',
        SUBMISSION_DEADLINE: 'SUBMISSION_DEADLINE_TABLE_HEADER',
        UPDATE_DATE: 'UPDATE_DATE_TABLE_HEADER',
        TAX: 'TAX_TABLE_HEADER',
        VALUE: 'VALUE_TABLE_HEADER',
        BASE_VALUE: 'BASE_VALUE_TABLE_HEADER',
        YEAR_VALUE: (year) => `YEAR_${year}_TABLE_HEADER`,
        STEP: 'STEP_TABLE_HEADER',
        ASSOCIATION_DATE: 'ASSOCIATION_DATE_TABLE_HEADER',
        ASSOCIATED_BY: 'ASSOCIATED_BY_TABLE_HEADER',
        COMMENT: 'COMMENT_TABLE_HEADER',
        NOTIFICATION_CLIENT: 'NOTIFICATION_CLIENT_NAME',
        NOTIFICATION_COMPANY: 'NOTIFICATION_COMPANY_NAME',
        NOTIFICATION: 'NOTIFICATION_TABLE_HEADER',
        NOTIFICATION_DATE: 'NOTIFICATION_DATE',
        NOTIFICATION_READ: 'NOTIFICATION_READ'
    },
    BUTTON: {
        ADD: 'ADD_BUTTON',
        FILTER: 'FILTER_BUTTON',
        COLUMNS: 'COLUMNS_BUTTON',
        EXPORT: 'EXPORT_BUTTON',
        CANCEL_MODAL: 'CANCEL_MODAL_BUTTON',
        OK_MODAL: 'OK_MODAL_BUTTON',
        DEACTIVATE_ACCESS: 'DEACTIVATE_ACCESS_BUTTON',
        REACTIVATE_ACCESS: 'REACTIVATE_ACCESS_BUTTON',
        ACTIONS: 'ACTIONS_BUTTON',
        LOGOUT: 'LOGOUT_BUTTON',
        COUNTER_PLUS: (counterAutomationId) => `${counterAutomationId}_PLUS_BUTTON`,
        COUNTER_MINUS: (counterAutomationId) => `${counterAutomationId}_MINUS_BUTTON`,
        ADD_FIELD: 'ADD_FIELD_BUTTON',
        REMOVE_FIELD: 'REMOVE_FIELD_BUTTON',
        EDIT: 'EDIT_BUTTON',
        VIEW: 'VIEW_BUTTON',
        UPLOAD_BALANCE: 'UPLOAD_BALANCE_BUTTON',
        STEPS: (index) => `STEP_${index}`,
        STEPS_SCROLL_RIGHT: 'STEPS_SCROLL_RIGHT_BUTTON',
        STEPS_SCROLL_LEFT: 'STEPS_SCROLL_LEFT_BUTTON',
        DOWNLOAD_BALANCE_TEMPLATE: 'DOWNLOAD_BALANCE_TEMPLATE_BUTTON',
        UPDATE_BALANCE_ACCOUNTS: 'UPDATE_BALANCE_ACCOUNTS_BUTTON',
        CREATE_CALCULATION_CONFIRMATION_MODAL_OK_BUTTON: 'CREATE_CALCULATION_CONFIRMATION_MODAL_OK_BUTTON',
        CREATE_CALCULATION_CONFIRMATION_MODAL_CANCEL_BUTTON: 'CREATE_CALCULATION_CONFIRMATION_MODAL_CANCEL_BUTTON',
        UPLOAD_BALANCE_ERROR_MODAL_OK_BUTTON: 'UPLOAD_BALANCE_ERROR_MODAL_OK_BUTTON',
        BALANCE_ACCOUNTS: 'BALANCE_ACCOUNTS_BUTTON',
        CANCEL_CALCULATION: 'CANCEL_CALCULATION_BUTTON',
        DOWNLOAD_DOCUMENT: 'DOWNLOAD_DOCUMENT_BUTTON',
        DELETE_DOCUMENT: 'DELETE_DOCUMENT_BUTTON',
        REDIRECT_HISTORICAL_MODULE: 'REDIRECT_HISTORICAL_MODULE',
        UNLINK_DOCUMENT: 'UNLINK_DOCUMENT_BUTTON',
        REUSE_SUPPORT_DOCUMENTS: 'REUSE_SUPPORT_DOCUMENTS_BUTTON',
        SAVE: 'SAVE_BUTTON',
        SEND_CALCULATION_TO_VERIFIER: 'SEND_CALCULATION_TO_VERIFIER_BUTTON',
        SEND_CALCULATION_TO_APPROVER: 'SEND_CALCULATION_TO_APPROVER_BUTTON',
        REJECT_CALCULATION: 'REJECT_CALCULATION_BUTTON',
        APPROVE_CALCULATION: 'APPROVE_CALCULATION_BUTTON',
        CLOSE_CALCULATION_FOR_SUBMISSION: 'CLOSE_CALCULATION_FOR_SUBMISSION_BUTTON',
        REOPEN_CALCULATION: 'REOPEN_CALCULATION_BUTTON',
        CONFIRM_CALCULATION_SUBMISSION: 'CONFIRM_CALCULATION_SUBMISSION_BUTTON',
        APPROVE_REOPENING_OF_CALCULATION: 'APPROVE_REOPNEING_OF_CALCULATION_BUTTON',
        REJECT_REOPENING_OF_CALCULATION: 'REJECT_REOPNEING_OF_CALCULATION_BUTTON',
        RECALL_CALCULATION: 'RECALL_CALCULATION_BUTTON',
        DOWNLOAD_REPORT: 'DOWNLOAD_REPORT_BUTTON',
        DOWNLOAD_RECORD_BOOK: 'DOWNLOAD_RECORD_BOOK_BUTTON',
        ASSIGN_CALCULATION: 'ASSIGN_CALCULATION_BUTTON',
        REPLACE_BALANCE: 'REPLACE_BALANCE_BUTTON',
        VIEW_CALCULATION: 'VIEW_CALCULATION_BUTTON',
        CALCULATION_DETAILS: 'CALCULATION_DETAILS_BUTTON',
        DOCUMENT_DETAILS: 'DOCUMENT_DETAILS_BUTTON',
        CLIENT_DETAILS: 'CLIENT_DETAILS_BUTTON',
        LEGISLATION: 'LEGISLATION_BUTTON',
        DOWNLOAD_BALANCE: 'DOWNLOAD_BALANCE_BUTTON',
        DELETE_CALCULATION: 'DELETE_CALCULATION_BUTTON',
        DELETE_COMPANY: 'DELETE_COMPANY_BUTTON',
        DELETE_CLIENT: 'DELETE_CLIENT_BUTTON',
        DEACTIVATE_CLIENT: 'DEACTIVATE_CLIENT',
        REACTIVATE_CLIENT: 'REACTIVATE_CLIENT',
        DEACTIVATE_OPERATIONS_CLIENT: 'DEACTIVATE_OPERATIONS_CLIENT',
        RESEND_INVITATIONS: 'RESEND_INVITATIONS',
        FILTER_CANCEL: 'CANCEL_FILTER',
        FILTER_RESET: 'RESET_FILTER',
        FILTER_SUBMIT: 'SUBMIT_FILTER'
    },
    DATA_ENTRY: {
        SHARED: {
            INPUT: {
                SEARCH: 'SEARCH_INPUT',
                COUNTER: (counterAutomationId) => `${counterAutomationId}_INPUT`
            },
            CHECKBOX: {
                GROUP_OPTION: (checkboxGroupAutomationId, sectionIndex, optionIndex) => `${checkboxGroupAutomationId}_SECTION_${sectionIndex}_OPTION_${optionIndex}`
            },
            SELECT: {
                PAGE_SIZE: 'PAGE_SIZE_SELECT',
                PAGE: (value) => `PAGE_${value}_SELECT_OPTION`,
                OPTION: (selectAutomationId, index) => `${selectAutomationId}_OPTION_${index}`,
                OPTION_VALUE: 'OPTION_VALUE'
            },
            RADIO: {
                GROUP_OPTION: (radioGroupAutomationId, sectionIndex, optionIndex) => `${radioGroupAutomationId}_SECTION_${sectionIndex}_OPTION_${optionIndex}`
            },
            TEXTAREA: {
                REASON: 'REASON_TEXTAREA'
            }
        },
        ADMIN: {
            EMAIL: 'EMAIL_INPUT',
            FIRST_NAME: 'FIRST_NAME_INPUT',
            LAST_NAME: 'LAST_NAME_INPUT'
        },
        CLIENT: {
            NAME: 'NAME_INPUT',
            FISCAL_IDENTIFIER: 'FISCAL_IDENTIFIER_INPUT',
            NUMBER_OF_COMPANIES: 'NUMBER_OF_COMPANIES_COUNTER',
            NUMBER_OF_USERS: 'NUMBER_OF_USERS_COUNTER',
            NUMBER_OF_GB_STORAGE: 'NUMBER_OF_GB_STORAGE_COUNTER',
            ROLES: 'ROLES_CHECKBOX_GROUP',
            FEATURES: 'FEATURES_CHECKBOX_GROUP',
            ADMIN: {
                FIRST_NAME: (index, isNew = false) => `CLIENT_ADMIN_FIRST_NAME_INPUT_${isNew ? 'NEW' : index}`,
                LAST_NAME: (index, isNew = false) => `CLIENT_ADMIN_LAST_NAME_INPUT_${isNew ? 'NEW' : index}`,
                EMAIL: (index, isNew = false) => `CLIENT_ADMIN_EMAIL_INPUT_${isNew ? 'NEW' : index}`,
                PHONE_NUMBER: (index, isNew = false) => `CLIENT_ADMIN_PHONE_NUMBER_INPUT_${isNew ? 'NEW' : index}`
            },
            DETAILS: {
                NAME: 'CLIENT_DETAILS_NAME',
                FISCAL_IDENTIFIER: 'CLIENT_DETAILS_FISCAL_IDENTIFIER',
                ADMINS_TABLE: 'CLIENT_DETAILS_ADMINS_TABLE',
                HISTORY_LOGS: 'CLIENT_DETAILS_HISTORY_LOGS'
            },
            LOGS: {
                EXTRA_FEATURES: (rowIndex, itemIndex, active) => `EXTRA_FEATURE_${rowIndex}_${itemIndex}_${active ? 'ACTIVE' : 'INACTIVE'}`
            }
        },
        COMPANY: {
            CLIENT: 'CLIENT_SELECT',
            FISCAL_IDENTIFIER: 'FISCAL_IDENTIFIER_INPUT',
            ACTIVITY_CODE: 'ACTIVITY_CODE_INPUT',
            NAME: 'NAME_INPUT',
            ADDRESS: 'ADDRESS_INPUT',
            PHONE_NUMBER: 'PHONE_NUMBER_INPUT',
            FAX_NUMBER: 'FAX_NUMBER_INPUT',
            EMAIL: 'EMAIL_INPUT',
            TAX_TYPE: 'TAX_TYPE_RADIO_GROUP',
            IS_BANK: 'IS_BANK_RADIO_GROUP',
            ROLES: 'ROLES_RADIO_GROUP',
            HAS_APPOINTEE: 'HAS_APPOINTEE_RADIO_GROUP',
            APPOINTEE: {
                FISCAL_IDENTIFIER: 'APPOINTEE_FISCAL_IDENTIFIER_INPUT',
                NAME: 'APPOINTEE_NAME_INPUT',
                ADDRESS: 'APPOINTEE_ADDRESS_INPUT',
                PHONE_NUMBER: 'APPOINTEE_PHONE_NUMBER_INPUT',
                FAX_NUMBER: 'APPOINTEE_FAX_NUMBER_INPUT',
                EMAIL: 'APPOINTEE_EMAIL_INPUT'
            },
            SIGNER: {
                FIRST_NAME: 'SIGNER_FIRST_NAME_INPUT',
                LAST_NAME: 'SIGNER_LAST_NAME_INPUT',
                ROLE: 'SIGNER_ROLE_INPUT'
            },
            FISCAL_YEAR_TYPE: 'FISCAL_YEAR_TYPE_RADIO_GROUP',
            FISCAL_YEAR: 'FISCAL_YEAR_SELECT'
        },
        USER: {
            EMAIL: 'EMAIL_INPUT',
            FIRST_NAME: 'FIRST_NAME_INPUT',
            LAST_NAME: 'LAST_NAME_INPUT',
            ASSOCIATION: {
                CLIENT: (index, isNew = false) => `USER_ASSOCIATION_CLIENT_SELECT_${isNew ? 'NEW' : index}`,
                COMPANY: (index, isNew = false) => `USER_ASSOCIATION_COMPANY_SELECT_${isNew ? 'NEW' : index}`,
                ROLES: (index, isNew = false) => `USER_ASSOCIATION_ROLES_RADIO_GROUP_${isNew ? 'NEW' : index}`
            }
        },
        CALCULATION: {
            CREATE_CALCULATION: {
                CLIENT: 'CLIENT_SELECT',
                COMPANY: 'COMPANY_SELECT',
                YEAR: 'YEAR_SELECT',
                QUARTER: 'QUARTER_SELECT',
                FILE: 'FILE_UPLOAD',
                USE_PREVIOUS_BALANCE: 'USE_PREVIOUS_BALANCE_SWITCH'
            },
            TIME_AND_BALANCE: {
                CLIENT: 'CLIENT_SELECT',
                COMPANY: 'COMPANY_SELECT',
                YEAR: 'YEAR_SELECT',
                QUARTER: 'QUARTER_SELECT'
            },
            STEP: {
                ITEM_LABEL: 'ITEM_LABEL',
                ITEM_INPUT: 'ITEM_INPUT',
                ITEM_SWITCH: 'ITEM_SWITCH',
                ITEM_COMMENTS_BUTTON: 'ITEM_COMMENTS_BUTTON',
                ITEM_MODIFY_INPUT: 'ITEM_MODIFY_INPUT',
                ITEM_CHECKBOX: 'ITEM_CHECKBOX',
                ITEM_SELECT: 'ITEM_SELECT',
                BALANCE_ACCOUNTS_BUTTON: 'BALANCE_ACCOUNTS_BUTTON',
                BALANCE_ACCOUNT_SWITCH: 'BALANCE_ACCOUNT_SWITCH',
                BALANCE_ACCOUNT_MODIFY_INPUT: 'BALANCE_ACCOUNT_MODIFY_INPUT',
                BALANCE_ACCOUNT_COMMENTS_BUTTON: 'BALANCE_ACCOUNT_COMMENTS_BUTTON',
                INHERITED_ACCOUNT_SWITCH: 'INHERITED_ACCOUNT_SWITCH',
                INHERITED_ACCOUNT_MODIFY_INPUT: 'INHERITED_ACCOUNT_MODIFY_INPUT',
                INHERITED_ACCOUNT_COMMENTS_BUTTON: 'INHERITED_ACCOUNT_COMMENTS_BUTTON',
                ROW_DESCRIPTION_INPUT: 'ROW_DESCRIPTION_INPUT',
                ROW_VALUE_INPUT: 'ROW_VALUE_INPUT',
                ROW_COMMENTS_BUTTON: 'ROW_COMMENTS_BUTTON',
                BALANCE_ACCOUNTS_TABLE: 'BALANCE_ACCOUNTS_TABLE',
                ITEMS_CARDS_CONTAINER: 'STEP_ITEMS_CARDS_CONTAINER',
                EXPANDLE_AREA_PANEL: 'EXPANDABLE_AREA_PANEL',
                DOCUMENTS_TABLE: 'DOCUMENTS_TABLE'
            },
            ACTIONS: {
                REJECT: {
                    COMMENT: 'REJECT_COMMENT_TEXTAREA'
                },
                SUBMISSION_CONFIRM: {
                    SUBMISSION_DATE: 'SUBMISSION_CONFIRM_SUBMISSION_DATE',
                    SUBMISSION_TYPE: 'SUBMISSION_CONFIRM_SUBMISSION_TYPE_RADIO_GROUP',
                    RECEIPT: 'SUBMISSION_CONFIRM_RECEIPT_FILE'
                }
            },
            SHARED: {
                CANCEL: 'CANCEL_BUTTON',
                SAVE: 'SAVE_BUTTON',
                NEXT_STEP: 'NEXT_STEP_BUTTON',
                PREVIOUS_STEP: 'PREVIOUS_STEP_BUTTON',
                EDIT_ROW: 'EDIT_ROW_BUTTON',
                SAVE_ROW: 'SAVE_ROW_BUTTON',
                CANCEL_ROW: 'CANCEL_ROW_BUTTON',
                REMOVE_ROW: 'REMOVE_ROW_BUTTON',
                ADD_ROW: 'ADD_ROW_BUTTON'
            }
        },
        DOCUMENTS: {
            CLIENT: 'CLIENT_SELECT',
            COMPANY: 'COMPANY_SELECT',
            UPLOAD: 'DOCUMENTS_UPLOAD'
        },
        COMMENTS: {
            ADD_COMMENT_TEXTAREA: 'ADD_COMMENT_TEXTAREA',
            ADD_COMMENT_BUTTON: 'ADD_COMMENT_BUTTON'
        },
        HISTORICAL_MODULE: {
            MAIN_TABLE: (historicalModuleTypePrefix) => `${historicalModuleTypePrefix}_MAIN_TABLE`,
            DEDUCTED_VALUES_FOR_YEAR_TABLE: (historicalModuleTypePrefix) => `${historicalModuleTypePrefix}_DEDUCTED_VALUES_FOR_YEAR_TABLE`,
            DEDUCTIBLE_VALUES_AFTER_YEAR_TABLE: (historicalModuleTypePrefix) => `${historicalModuleTypePrefix}_DEDUCTIBLE_VALUES_AFTER_YEAR_TABLE`,
            FISCAL_PROFIT_LOSS_VALUE: 'FISCAL_PROFIT_LOSS_VALUE_FIELD',
            EXCESS_COST_DEDUCTIBLE_VALUE: 'EXCESS_COST_DEDUCTIBLE_VALUE_FIELD',
            EXCESS_COST_LOAN_CURRENT_PERIOD_VALUE: 'EXCESS_COST_LOAN_CURRENT_PERIOD_VALUE_FIELD',
            EXCESS_COST_LOAN_AFTER_PERIOD_VALUE: 'EXCESS_COST_LOAN_AFTER_PERIOD_VALUE_FIELD',
            SPONSORSHIP_EXPENSES_EXCEEDING_LIMIT_VALUE: 'SPONSORSHIP_EXPENSES_EXCEEDING_LIMIT_VALUE_FIELD',
            SPONSORSHIP_EXPENSES_UNUSED_VALUE: 'SPONSORSHIP_EXPENSES_UNUSED_VALUE_FIELD',
            FISCAL_LOSS_TABLE: 'FISCAL_LOSS_TABLE',
            EXCESS_COST_TABLE: 'EXCESS_COST_TABLE',
            SPONSORSHIP_TABLE: 'SPONSORSHIP_TABLE',
            FISCAL_LOSS_INPUT: (index) => `FISCAL_LOSS_INPUT_${index}`,
            EXCESS_COST_INPUT: (index) => `EXCESS_COST_INPUT_${index}`,
            SPONSORSHIP_INPUT: (index) => `SPONSORSHIP_INPUT_${index}`
        }
    },
    SHARED: {
        EMPTY_TABLE: 'EMPTY_TABLE_CONTAINER'
    }
};
